import { API_ORIGIN } from './api';

const STORAGE_KEY = 'tts_visit_identity';
const UUID = /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i;
const LANDING_PATHS = ['/', '/lists', '/schedule', '/completed', '/settings'];
let memoryIdentity = null;

export function visitsAllowed() {
  return navigator.globalPrivacyControl !== true && ![navigator.doNotTrack, window.doNotTrack].includes('1');
}
function randomId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  if (!window.crypto?.getRandomValues) return null;
  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
function referralOrigin(value) {
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) && url.origin !== window.location.origin ? url.origin : null;
  } catch { return null; }
}
function acquisitionPath(value) {
  const url = new URL(value, window.location.origin), kept = new URLSearchParams();
  for (const key of ['source', 'utm_source', 'utm_medium', 'utm_campaign']) {
    const value = url.searchParams.get(key);
    if (value && /^[a-z0-9_-]{1,80}$/i.test(value)) kept.set(key, value);
  }
  const path = LANDING_PATHS.includes(url.pathname) ? url.pathname : '/';
  return `${path}${kept.size ? `?${kept}` : ''}`;
}
export function visitIdentity() {
  if (!visitsAllowed()) return null;
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (saved && UUID.test(saved.anon_id) && typeof saved.path === 'string') {
      // Rebuild the allowlisted payload, never send arbitrary stored properties.
      memoryIdentity = { anon_id: saved.anon_id, referrer: referralOrigin(saved.referrer), path: acquisitionPath(saved.path) };
      return memoryIdentity;
    }
  } catch { /* Tracking storage must never block the app. */ }
  if (memoryIdentity) return memoryIdentity;
  const anon_id = randomId(); if (!anon_id) return null;
  // Visit-only ID, not an account/lifecycle identifier or entitlement proof.
  // Preserve the first landing, including an untagged/direct first visit.
  memoryIdentity = { anon_id, referrer: referralOrigin(document.referrer), path: acquisitionPath(window.location.href) };
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(memoryIdentity)); } catch {}
  return memoryIdentity;
}
export async function recordVisit() {
  let timeout;
  try {
    const identity = visitIdentity(); if (!identity || !API_ORIGIN) return false;
    const controller = new AbortController();
    timeout = setTimeout(() => controller.abort(), 6000);
    const response = await fetch(`${API_ORIGIN}/api/track/visit`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(identity),
      credentials: 'omit', referrerPolicy: 'no-referrer', cache: 'no-store', keepalive: true, signal: controller.signal,
    });
    return response.ok;
  } catch { return false; }
  finally { clearTimeout(timeout); }
}